import { useState } from "react"

import iconAntigravity from "../Images/connections/antigravity.png"
import iconClaudeCode from "../Images/connections/claude-code.png"
import iconClaude from "../Images/connections/claude.png"
import iconCodex from "../Images/connections/codex.png"
import iconCursor from "../Images/connections/cursor.png"
import iconDevin from "../Images/connections/devin.png"
import iconChatGPT from "../Images/connections/gpt.png"
import iconGrok from "../Images/connections/grok.png"
import iconMistral from "../Images/connections/mistral.png"
import { CodeBlock, DiscSection, EndpointBox, MCP_URL, Notice, Step } from "./ui"

const CURSOR_CONFIG = `{
  "mcpServers": {
    "Chargeback": {
      "command": "npx",
      "args": ["-y", "mcp-remote@latest", "${MCP_URL}"]
    }
  }
}`

const CLIENTS = [
  {
    id: "claude",
    label: "Claude",
    bg: "#fff",
    border: "1px solid #eee",
    icon: <img src={iconClaude} style={{ width: 13, height: 13, display: "block" }} alt="" />
  },
  {
    id: "claude-code",
    label: "Claude Code",
    bg: "#fff",
    border: "1px solid #eee",
    icon: <img src={iconClaudeCode} style={{ width: 13, height: 13, display: "block" }} alt="" />
  },
  {
    id: "chatgpt",
    label: "ChatGPT",
    bg: "#fff",
    border: "1px solid #eee",
    icon: <img src={iconChatGPT} style={{ width: 13, height: 13, display: "block" }} alt="" />
  },
  {
    id: "cursor",
    label: "Cursor",
    bg: "#fff",
    border: "1px solid #eee",
    icon: <img src={iconCursor} style={{ width: 13, height: 13, display: "block" }} alt="" />
  },
  {
    id: "codex",
    label: "Codex",
    bg: "#fff",
    border: "1px solid #eee",
    icon: <img src={iconCodex} style={{ width: 13, height: 13, display: "block" }} alt="" />
  },
  {
    id: "grok",
    label: "Grok",
    bg: "#fff",
    border: "1px solid #eee",
    icon: <img src={iconGrok} style={{ width: 13, height: 13, display: "block" }} alt="" />
  },
  {
    id: "mistral",
    label: "Mistral AI",
    bg: "#fff",
    border: "1px solid #eee",
    icon: <img src={iconMistral} style={{ width: 13, height: 13, display: "block" }} alt="" />
  },
  {
    id: "devin",
    label: "Devin",
    bg: "#fff",
    border: "1px solid #eee",
    icon: <img src={iconDevin} style={{ width: 13, height: 13, display: "block" }} alt="" />
  },
  {
    id: "antigravity",
    label: "Antigravity IDE",
    bg: "#fff",
    border: "1px solid #eee",
    icon: <img src={iconAntigravity} style={{ width: 13, height: 13, display: "block" }} alt="" />
  },
  {
    id: "other",
    label: "Other clients",
    bg: "#6366f1",
    icon: (
      <svg width="10" height="10" viewBox="0 0 20 20" fill="#fff">
        <path
          fillRule="evenodd"
          d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
          clipRule="evenodd"
        />
      </svg>
    )
  }
]

const ClaudePanel = ({ openDisc, toggleDisc }) => (
  <>
    <div className="mcp-doc-steps">
      <Step
        num="1"
        title={
          <>
            Go to <strong>Customize → Connectors</strong>
          </>
        }
      >
        <p>Open Claude (web or desktop) and navigate to Customize → Connectors.</p>
        <Notice type="info" style={{ marginTop: 8 }}>
          If you're on a <strong>Team or Enterprise plan</strong>, an Owner must add the connector.
          If you don't see the option, contact your workspace Owner.
        </Notice>
      </Step>
      <Step
        num="2"
        title={
          <>
            Click <strong>+</strong> → <strong>Add custom connector</strong>
          </>
        }
      />
      <Step num="3" title={<>Name it and paste the server URL</>}>
        <p>
          Name it <strong>Chargeback</strong>. In the <strong>Remote MCP server URL</strong> field,
          paste:
        </p>
        <CodeBlock text={MCP_URL} />
        <p style={{ marginTop: 8 }}>
          Leave the OAuth fields empty, then click <strong>Add</strong>.
        </p>
      </Step>
      <Step
        num="4"
        title={
          <>
            Click <strong>Connect</strong>, then <strong>Allow</strong>
          </>
        }
      >
        <p>Keep all three permission boxes checked. You can revoke access at any time.</p>
      </Step>
    </div>
    <DiscSection id="claude" openId={openDisc} onToggle={toggleDisc}>
      <p>
        Go to <strong>Customize → Connectors</strong>, find Chargeback, click the{" "}
        <strong>···</strong> menu, and click <strong>Disconnect</strong>. Access is revoked
        immediately.
      </p>
    </DiscSection>
  </>
)

const ClaudeCodePanel = ({ openDisc, toggleDisc }) => (
  <>
    <div className="mcp-doc-steps">
      <Step num="1" title="In your Terminal, run this command">
        <CodeBlock
          text={`claude mcp add --transport http chargeback ${process.env.REACT_APP_MCP_SERVER_URL || "https://mcp.mcp-int.chargeback.io/mcp"}`}
        />
      </Step>
      <Step
        num="2"
        title="After adding the MCP server, trigger the authentication with Chargeback with the command"
      >
        <CodeBlock text="claude /mcp" />
      </Step>
      <Step
        num="3"
        title={
          <>
            Sign in and click <strong>Allow</strong>
          </>
        }
      >
        <p>
          Claude Code sends you to Chargeback to sign in if you aren&apos;t already. Keep all three
          boxes checked, then click <strong>Allow</strong>.
        </p>
      </Step>
    </div>
    <DiscSection id="claude-code" openId={openDisc} onToggle={toggleDisc}>
      <CodeBlock text="claude mcp remove chargeback" />
      <Notice type="info" style={{ marginTop: 8 }}>
        If Chargeback still appears, run <code>claude mcp list</code> to find all entries (it may be
        registered as <code>chargeback_dev</code>), then <code>claude mcp remove &lt;name&gt;</code>
        .
      </Notice>
    </DiscSection>
  </>
)

const ChatGPTPanel = ({ openDisc, toggleDisc }) => (
  <>
    <div className="mcp-doc-steps">
      <Step
        num="1"
        title={
          <>
            Go to <strong>Settings</strong>, then <strong>Plugins</strong>
          </>
        }
      >
        <Notice type="info" style={{ marginTop: 8 }}>
          On a <strong>Business or Enterprise</strong> workspace, only an admin can turn this on.
          Only add connectors you trust.
        </Notice>
      </Step>
      <Step
        num="2"
        title={
          <>
            Check <strong>Permissions</strong>
          </>
        }
      >
        <p>
          Ensure the <strong>Permissions</strong> settings align with your needs and click{" "}
          <strong>Browse plugins</strong>.
        </p>
      </Step>
      <Step num="3" title="Name it and paste the server URL">
        <p>
          Click the plus next to the <strong>Search plugins</strong> field. Enter a name you&apos;ll
          recognize later, like <strong>Chargeback</strong>. Under <strong>Connection</strong>, in
          the <strong>Server URL</strong> field, paste:
        </p>
        <CodeBlock text={MCP_URL} />
        <p style={{ marginTop: 8 }}>
          Leave the other settings at their defaults. If ChatGPT warns about the risk of custom MCP
          servers, confirm to continue, then click <strong>Create</strong>.
        </p>
      </Step>
      <Step
        num="4"
        title={
          <>
            Sign in and click <strong>Allow</strong>
          </>
        }
      >
        <p>
          Click <strong>Sign in to continue</strong>. ChatGPT opens Chargeback in a browser. Keep
          all three boxes checked and click <strong>Allow</strong>.
        </p>
      </Step>
    </div>
    <DiscSection id="chatgpt" openId={openDisc} onToggle={toggleDisc}>
      <p>
        Go to <strong>Settings → Plugins</strong>, find Chargeback, and click{" "}
        <strong>Disconnect</strong>. Access is revoked immediately.
      </p>
    </DiscSection>
  </>
)

const CursorPanel = ({ openDisc, toggleDisc }) => (
  <>
    <div className="mcp-doc-steps">
      <Step
        num="1"
        title={
          <>
            Open <strong>Settings → Tools &amp; MCPs</strong>
          </>
        }
      >
        <p>
          Click the gear icon at the bottom left, then select <strong>Tools &amp; MCPs</strong>.
        </p>
        <Notice type="info" style={{ marginTop: 8 }}>
          MCP servers are available on all Cursor plans, but the <strong>Free tier</strong> may
          limit or disable MCP access. On a <strong>Business plan</strong>, an admin must enable MCP
          access for the team.
        </Notice>
      </Step>
      <Step
        num="2"
        title={
          <>
            Click <strong>Add Custom MCP</strong> and paste the config
          </>
        }
      >
        <p>
          Cursor opens your <code>mcp.json</code> config file. Paste the following and save:
        </p>
        <CodeBlock text={CURSOR_CONFIG} />
      </Step>
      <Step
        num="3"
        title={
          <>
            Sign in and click <strong>Allow</strong>
          </>
        }
      >
        <p>
          Cursor opens a browser window. Keep all three boxes checked and click{" "}
          <strong>Allow</strong>.
        </p>
      </Step>
    </div>
    <DiscSection id="cursor" openId={openDisc} onToggle={toggleDisc}>
      <p>
        Go to <strong>Settings → Tools &amp; MCPs</strong>, find Chargeback under{" "}
        <strong>Home MCP Servers</strong>, hover to reveal actions, then click the{" "}
        <strong>trash icon</strong> and confirm. Access is revoked immediately.
      </p>
    </DiscSection>
  </>
)

const CodexPanel = ({ openDisc, toggleDisc }) => (
  <>
    <div className="mcp-doc-steps">
      <Step
        num="1"
        title={
          <>
            Go to <strong>Settings → MCP servers</strong>
          </>
        }
      >
        <p>
          Click your username at the bottom left, then go to <strong>Settings → MCP servers</strong>
          .
        </p>
      </Step>
      <Step
        num="2"
        title={
          <>
            Click <strong>+ Add server</strong>, switch to <strong>Streamable HTTP</strong>
          </>
        }
      />
      <Step num="3" title="Name it and paste the server URL">
        <p>
          Name it <strong>Chargeback</strong>. In the <strong>Server URL</strong> field, paste:
        </p>
        <CodeBlock text={MCP_URL} />
        <p style={{ marginTop: 8 }}>
          Leave all other settings at their defaults, then click <strong>Save</strong>.
        </p>
      </Step>
      <Step num="4" title="Run the login command in a new chat">
        <p>
          Start a new Codex chat and send this command (replace <code>chargeback</code> with your
          connector name if it differs):
        </p>
        <CodeBlock text="Run outside sandbox: codex mcp login chargeback" />
        <p style={{ marginTop: 8 }}>
          When Codex asks for approval to run outside the sandbox, select <strong>Yes</strong> and
          click <strong>Submit</strong>.
        </p>
      </Step>
      <Step
        num="5"
        title={
          <>
            Sign in and click <strong>Allow</strong>
          </>
        }
      >
        <p>
          Codex opens a browser window. Keep all three boxes checked and click{" "}
          <strong>Allow</strong>.
        </p>
      </Step>
    </div>
    <DiscSection id="codex" openId={openDisc} onToggle={toggleDisc}>
      <p>
        Go to <strong>Settings → MCP servers</strong>, find Chargeback, and toggle it off. Access is
        revoked immediately.
      </p>
    </DiscSection>
  </>
)

const GrokPanel = ({ openDisc, toggleDisc }) => (
  <>
    <Notice type="info" style={{ marginBottom: 12 }}>
      MCP servers are supported across all Grok plans, but the <strong>Free tier</strong> may limit
      or disable MCP access. On <strong>Business plans</strong>, an admin may need to enable MCP
      access for the team.
    </Notice>
    <div className="mcp-doc-steps">
      <Step
        num="1"
        title={
          <>
            Go to <strong>Skills and Connectors → Connectors tab</strong>
          </>
        }
      />
      <Step
        num="2"
        title={
          <>
            Click <strong>New Connector → Custom</strong>
          </>
        }
      />
      <Step num="3" title="Name it and paste the server URL">
        <p>
          Name it <strong>Chargeback</strong>. In the <strong>Server URL</strong> field, paste:
        </p>
        <CodeBlock text={MCP_URL} />
        <p style={{ marginTop: 8 }}>
          Click <strong>Add Connector</strong>.
        </p>
      </Step>
      <Step
        num="4"
        title={
          <>
            Sign in and click <strong>Allow</strong>
          </>
        }
      >
        <p>
          Grok opens Chargeback in a browser. Keep all three boxes checked and click{" "}
          <strong>Allow</strong>.
        </p>
      </Step>
    </div>
    <DiscSection id="grok" openId={openDisc} onToggle={toggleDisc}>
      <p>
        Go to <strong>Skills and Connectors → Connectors tab</strong>, click Chargeback, then click{" "}
        <strong>Disconnect</strong>. Access is revoked immediately.
      </p>
    </DiscSection>
  </>
)

const MistralPanel = ({ openDisc, toggleDisc }) => (
  <>
    <Notice type="info" style={{ marginBottom: 12 }}>
      MCP servers are supported across all Mistral plans, but the <strong>Free tier</strong> may
      limit or disable MCP access. On a <strong>Team plan</strong>, an admin may need to enable MCP
      access for the team.
    </Notice>
    <div className="mcp-doc-steps">
      <Step
        num="1"
        title={
          <>
            Go to <strong>Context → Connectors</strong>
          </>
        }
      />
      <Step
        num="2"
        title={
          <>
            Click <strong>Add Connector → Custom MCP Connector</strong>
          </>
        }
      />
      <Step num="3" title="Name it and paste the server URL">
        <p>
          Name it <strong>Chargeback</strong>. In the <strong>Connector Server</strong> field,
          paste:
        </p>
        <CodeBlock text={MCP_URL} />
      </Step>
      <Step
        num="4"
        title={
          <>
            Sign in and click <strong>Allow</strong>
          </>
        }
      >
        <p>
          Mistral opens Chargeback in a browser. Keep all three boxes checked and click{" "}
          <strong>Allow</strong>.
        </p>
      </Step>
    </div>
    <DiscSection id="mistral" openId={openDisc} onToggle={toggleDisc}>
      <p>
        Go to <strong>Context → Connectors</strong>, find Chargeback, open the dropdown next to New
        Chat, and select <strong>Disconnect</strong>. Access is revoked immediately.
      </p>
    </DiscSection>
  </>
)

const DevinPanel = ({ openDisc, toggleDisc }) => (
  <>
    <Notice type="info" style={{ marginBottom: 12 }}>
      MCP servers are available on all Devin plans, but the <strong>Free tier</strong> may limit or
      disable MCP access. On <strong>Business plans</strong>, an admin may need to enable MCP access
      for the team.
    </Notice>
    <div className="mcp-doc-steps">
      <Step
        num="1"
        title={
          <>
            Go to <strong>Settings → Connections → MCP servers tab</strong>
          </>
        }
      />
      <Step
        num="2"
        title={
          <>
            Click <strong>Add a custom MCP</strong>
          </>
        }
      />
      <Step num="3" title="Configure the server">
        <p>
          Set <strong>Server name</strong> to <strong>Chargeback</strong>. Set{" "}
          <strong>Transport type</strong> to <strong>HTTP</strong> and{" "}
          <strong>Authentication</strong> to <strong>OAuth</strong>. In the{" "}
          <strong>Server URL</strong> field, paste:
        </p>
        <CodeBlock text={MCP_URL} />
        <p style={{ marginTop: 8 }}>
          Click <strong>Install and enable</strong>. If Devin warns about custom MCP servers,
          confirm to continue.
        </p>
      </Step>
      <Step
        num="4"
        title={
          <>
            Click <strong>Complete OAuth</strong>, then sign in and allow
          </>
        }
      >
        <p>
          Devin opens Chargeback in a browser. Keep all three boxes checked and click{" "}
          <strong>Allow</strong>.
        </p>
      </Step>
    </div>
    <DiscSection id="devin" openId={openDisc} onToggle={toggleDisc}>
      <p>
        Go to <strong>Settings → Connections → MCP servers</strong>, find Chargeback, open its
        settings, and click <strong>Delete MCP</strong>. Access is revoked immediately.
      </p>
    </DiscSection>
  </>
)

const AntigravityPanel = ({ openDisc, toggleDisc }) => (
  <>
    <Notice type="info" style={{ marginBottom: 12 }}>
      MCP servers are supported across all Antigravity plans, but the <strong>Free tier</strong> may
      limit or disable MCP access. On an <strong>Organization plan</strong>, an admin may need to
      enable MCP access for the team.
    </Notice>
    <div className="mcp-doc-steps">
      <Step
        num="1"
        title={
          <>
            Open <strong>Additional Options → MCP Servers</strong>
          </>
        }
      >
        <p>
          In the Agent panel, click the <strong>···</strong> icon to open Additional Options, then
          select <strong>MCP Servers</strong>.
        </p>
      </Step>
      <Step
        num="2"
        title={
          <>
            Click <strong>View raw config</strong>
          </>
        }
      />
      <Step num="3" title="Paste the config and save">
        <p>
          Paste the following into the config file, then save with <strong>Cmd+S</strong> (macOS) or{" "}
          <strong>Ctrl+S</strong> (Windows):
        </p>
        <CodeBlock text={CURSOR_CONFIG} />
      </Step>
      <Step
        num="4"
        title={
          <>
            Switch to <strong>Manage MCPs</strong> tab and click <strong>Refresh</strong>
          </>
        }
      >
        <p>Confirm the server appears as connected.</p>
      </Step>
      <Step
        num="5"
        title={
          <>
            Sign in and click <strong>Allow</strong>
          </>
        }
      >
        <p>
          Antigravity IDE opens a browser window. Keep all three permission boxes checked and click{" "}
          <strong>Allow</strong>. You can revoke access at any time.
        </p>
      </Step>
    </div>
    <DiscSection id="antigravity" openId={openDisc} onToggle={toggleDisc}>
      <p>
        Click the <strong>···</strong> menu at the top of the agent panel, select{" "}
        <strong>MCP Servers → Manage MCP Servers</strong>, find Chargeback, and toggle off the{" "}
        <strong>Enabled</strong> switch. Access is revoked immediately.
      </p>
    </DiscSection>
  </>
)

const OtherPanel = ({ openDisc, toggleDisc }) => (
  <>
    <div className="mcp-doc-steps">
      <Step num="1" title="Paste the endpoint URL into your client's MCP settings">
        <p>
          Any client that supports the streamable-HTTP transport and OAuth 2.1 will work. Look for
          an MCP, connectors, or integrations section in your client's settings.
        </p>
        <EndpointBox />
      </Step>
      <Step num="2" title="Complete the OAuth flow">
        <p>
          The client discovers how to authenticate automatically. You'll be redirected to Chargeback
          to log in and approve access. No API key needed.
        </p>
      </Step>
    </div>
    <DiscSection id="other" openId={openDisc} onToggle={toggleDisc}>
      <p>
        Remove the Chargeback server from your client's MCP or connector settings. Access is revoked
        immediately on the next tool call.
      </p>
    </DiscSection>
  </>
)

const PANELS = {
  claude: ClaudePanel,
  "claude-code": ClaudeCodePanel,
  chatgpt: ChatGPTPanel,
  cursor: CursorPanel,
  codex: CodexPanel,
  grok: GrokPanel,
  mistral: MistralPanel,
  devin: DevinPanel,
  antigravity: AntigravityPanel,
  other: OtherPanel
}

const ConnectSection = () => {
  const [activeClient, setActiveClient] = useState("claude")
  const [openDisc, setOpenDisc] = useState(null)

  const toggleDisc = (id) => setOpenDisc((prev) => (prev === id ? null : id))

  const handleClientClick = (id) => {
    setActiveClient(id)
    setOpenDisc(null)
  }

  const Panel = PANELS[activeClient]

  return (
    <div className="mcp-doc-connect-layout">
      <nav className="mcp-doc-client-nav">
        {CLIENTS.map((client) => (
          <button
            key={client.id}
            className={`mcp-doc-client-nav-item${activeClient === client.id ? " active" : ""}`}
            onClick={() => handleClientClick(client.id)}
          >
            <div
              className="mcp-doc-client-nav-icon"
              style={{ background: client.bg, border: client.border }}
            >
              {client.icon}
            </div>
            {client.label}
          </button>
        ))}
      </nav>
      <div className="mcp-doc-connect-panel-area">
        {Panel && <Panel openDisc={openDisc} toggleDisc={toggleDisc} />}
      </div>
    </div>
  )
}

export default ConnectSection
